import React, { useRef } from 'react'
import FileUpload from '../../../../../components/atoms/FileUpload.atom'
import Button from '../../../../../components/atoms/Button.atom'
import { MAX_FILE_SIZE_CLIENT_LOGO, TYPES_CLIENT_IMAGES_ACCEPTED } from '../../../../../consts/modules/clients.consts'
import useToast from '../../../../../hooks/useToast.hook'
import { imageFormatSize } from '../../../../../utils/image.utils'
import useThemeContext from '../../../../../hooks/contextConsumers/useThemeContext.hook'

const ClientLogo = ({clientImg = null, onImageChange = () => {}, isClientView = false, logoUrl = null, clientName = undefined, onEdit = () => {}}) => {
 const imgUploaderRef = useRef(null)
 const { setErrorMessage } = useToast()
 const { theme } = useThemeContext()
 
 const chooseOptions = {
   icon: 'pi pi-upload', 
   label: 'Subir imagen',
   className: `theme-${theme}` 
 }

 const handleSelect = (event) => {
    const file = event.files && event.files[0]

    if (!file) return
    if (!TYPES_CLIENT_IMAGES_ACCEPTED.includes(file.type)) {
        setErrorMessage({ message: "Formato no válido. Solo se aceptan archivos PNG y JPG." })
        if (imgUploaderRef.current) {
            imgUploaderRef.current.clear()
        }
        return
    }
    if (file.size > MAX_FILE_SIZE_CLIENT_LOGO) {
        setErrorMessage({ message: `El tamaño es incorrecto (Máx: ${imageFormatSize(MAX_FILE_SIZE_CLIENT_LOGO)})` })
        if (imgUploaderRef.current) {
            imgUploaderRef.current.clear();
        }
        return
    }
    onImageChange(file)
}

 const handleRemove = () => {
    onImageChange(null)
    if(imgUploaderRef.current) {
      imgUploaderRef.current.clear()
    }
}


 
  const headerTemplate = (options) => {
    const { chooseButton } = options
    if(clientImg) return null
    return (
        <div className='file-upload-client-header'>
            {chooseButton}
        </div>
    )
  }

  const content = () => {
    const code = clientImg?.name?.split('-')[1] || ''
    const extension = clientImg?.name?.split('.').pop() || ''
    const realName = code && extension ? `${code}.${extension}` : clientImg.name
    return (
      <div className='file-upload-client-item-template'>
        <div className='img-data-container'>
          <img src={clientImg.objectURL} alt={clientImg.name}/>
          <div className={`img-data theme-${theme}`}>
            <span>{realName}</span>
            <span>{imageFormatSize(clientImg.size)}</span>
          </div>
        </div>
        <Button onClick={handleRemove} icon="pi pi-trash"/>
    </div>
    )
  }

 const emptyTemplate = () => {
  if(clientImg && typeof clientImg === 'object') return content()
    return (
        <div className={`file-upload-client-empty theme-${theme}`}>
            <span>Archivo JPG/PNG (máx. {imageFormatSize(MAX_FILE_SIZE_CLIENT_LOGO)})</span>
        </div>
    )
 }
 
 const itemTemplate = () => {
    if(!clientImg || typeof clientImg !== 'object') return null
    
    return content()
 }


 if (isClientView) {
  return (
     <div className="flex flex-column h-full">
        <h3 className="font-mulish text-base font-semibold clr-secondary m-0 mb-2">
          Logotipo
        </h3>
        <div className="client-image-container">
         <div className="image-content">
            {logoUrl ? (
              <img src={logoUrl} alt={clientName || "Logotipo"} />
            ) : (
              <i className="pi pi-image empty-icon" />
            )}
          </div>
          <div className="hover-content">
             <Button 
               icon="pi pi-pencil" 
               onClick={onEdit}
             />
          </div>
        </div>
      </div>
  )
 }
 
 return (
  <FileUpload 
    ref={imgUploaderRef}
    chooseOptions={chooseOptions}
    headerTemplate={headerTemplate}
    emptyTemplate={emptyTemplate}
    contentClassName='file-upload-content'
    multiple={false}
    onSelect={handleSelect}
    itemTemplate={itemTemplate}
    onBeforeDrop={() => false}  
    accept={TYPES_CLIENT_IMAGES_ACCEPTED}
  />
 )
}

export default ClientLogo